/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Onboarding_Birth_Year_HintInputs */

const en_ui_onboarding_birth_year_hint = /** @type {(inputs: Ui_Onboarding_Birth_Year_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For calories from heart rate`)
};

const de_ui_onboarding_birth_year_hint = /** @type {(inputs: Ui_Onboarding_Birth_Year_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für Kalorien aus der Herzfrequenz`)
};

/**
* | output |
* | --- |
* | "For calories from heart rate" |
*
* @param {Ui_Onboarding_Birth_Year_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_onboarding_birth_year_hint = /** @type {((inputs?: Ui_Onboarding_Birth_Year_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Onboarding_Birth_Year_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_onboarding_birth_year_hint(inputs)
	return de_ui_onboarding_birth_year_hint(inputs)
});